import Loader from "@Common/Loader";
import { Suspense, lazy } from "react";
import { useParams } from "react-router-dom";

import Carousel from "./Carousel";
import Main from "./Main";
import ToastComponent from "../components/ToastComponent";

const NotFound = lazy(() => import("@NotFound"));

const pages = {
    documents: lazy(() => import("./Documents")),
    promotion: lazy(() => import("./Promotion")),
    carousel: Carousel,
};

const Containers = () => {
    const { firstParam } = useParams();

    const Specified = firstParam ? (pages[firstParam] ? pages[firstParam] : NotFound) : Main;

    return (
        <>
            <ToastComponent />
            <Suspense fallback={<Loader />}>
                <Specified />
            </Suspense>
        </>
    );
};

export default Containers;
